export const removeFalsy = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    // eslint-disable-next-line no-unused-expressions
    obj[key] && obj[key] !== '0' && (acc[key] = obj[key]);
    return acc;
  }, {});
};
